<template>
  <div :v-if="list.length" class="cataloguePavilion">
    <div class="pavilion" v-for="(item,i) in list" :key="i">
      <div class="pavilionImg">
        <el-image 
          :lazy="true"
          fit="cover"
          :src="item.minurl" 
          :preview-src-list="[item.maxurl]">
        </el-image>
      </div>
      <div class="cataContent">
        <div class="pavilionTitle">
          <div>{{item.code}}</div>
          <div>
            <h2>{{item.title_en}}</h2>
            <p><a :href="item.maxurl" target="_block">click</a></p>
          </div>
        </div>
        <p v-for="(conItem,i) in item.contentArr_en" :key="i">{{conItem}}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      list:[
        {
          title_cn:"东1号馆",
          title_en:"Hall E1",
          code:"E1",
          minurl:"https://public.cippe.com.cn/static/hall/suoluetu/hall_e1.jpg",
          maxurl:"https://public.cippe.com.cn/static/hall/2026bj/hall_e1.jpg",
          contentArr_cn:["中石油展团","石油勘探","钻采设备"],
          contentArr_en:["CNPC Pavilion","E&P Equipment"]
        },
        {
          title_cn:"东2号馆",
          title_en:"Hall E2",
          code:"E2",
          minurl:"https://public.cippe.com.cn/static/hall/suoluetu/hall_e2.jpg",
          maxurl:"https://public.cippe.com.cn/static/hall/2026bj/hall_e2.jpg",
          contentArr_cn:["中石油展团","石油勘探","钻采设备"],
          contentArr_en:["SINOPEC Pavilion","E&P Equipment"]
        },
        {
          title_cn:"东3号馆",
          title_en:"Hall E3",
          code:"E3",
          minurl:"https://public.cippe.com.cn/static/hall/suoluetu/hall_e3.jpg",
          maxurl:"https://public.cippe.com.cn/static/hall/2026bj/hall_e3.jpg",
          contentArr_cn:["石油勘探及钻采设备"],
          contentArr_en:["E&P Equipment"]
        },
        {
          title_cn:"东4号馆",
          title_en:"Hall E4",
          code:"E4",
          minurl:"https://public.cippe.com.cn/static/hall/suoluetu/hall_e4.jpg",
          maxurl:"https://public.cippe.com.cn/static/hall/2026bj/hall_e4.jpg",
          contentArr_cn:["天然气","燃气","防爆","安全防护"],
          contentArr_en:["Natural Gas","City Gas","Explosion-proof","Safety Protection"],
        },
        {
          title_cn:"西1号馆",
          title_en:"Hall W1",
          code:"W1",
          minurl:"https://public.cippe.com.cn/static/hall/suoluetu/hall_w1.jpg",
          maxurl:"https://public.cippe.com.cn/static/hall/2026bj/hall_w1.jpg",
          contentArr_cn:["国际展团","海洋石油"],
          contentArr_en:["International Pavilion & Exhibitors", "Offshore Oil & Gas"],
        },
        {
          title_cn:"西2号馆",
          title_en:"Hall W2",
          code:"W2",
          minurl:"https://public.cippe.com.cn/static/hall/suoluetu/hall_w2.jpg",
          maxurl:"https://public.cippe.com.cn/static/hall/2026bj/hall_w2.jpg",
          contentArr_cn:["国际展区","海洋工程"],
          contentArr_en:["International Exhibitors", "Offshore Engineering"],
        },
        {
          title_cn:"西3号馆",
          title_en:"Hall W3",
          code:"W3",
          minurl:"https://public.cippe.com.cn/static/hall/suoluetu/hall_w3.jpg",
          maxurl:"https://public.cippe.com.cn/static/hall/2026bj/hall_w3.jpg",
          contentArr_cn:["管道","流体机械","仪器仪表","非开挖设备及技术"],
          contentArr_en:["Pipeline","Fluid Machinery Instrument","Trenchless"],
        },
        {
          title_cn:"西4号馆",
          title_en:"Hall W4",
          code:"W4",
          minurl:"https://public.cippe.com.cn/static/hall/suoluetu/hall_w4.jpg",
          maxurl:"https://public.cippe.com.cn/static/hall/2026bj/hall_w4.jpg",
          contentArr_cn:["氢能装备馆"],
          contentArr_en:["Hydrogen"],
        }
      ]
    }
  }
}
</script>
<style scoped>  
  .pavilion{
    width: 100%;
    height: 250px;
    background: white;
    margin-bottom: 11px;
    box-sizing: border-box;
    padding: 10px;
    display: flex;
  }
  .pavilionImg{
    width: 48%;
    height: 100%;
    border: 2px solid #eff0f0;
    overflow: hidden;
  }
  .pavilionImg>div{
    width: 100%;
    height: 100%;
  }
  .pavilionImg>>>.el-image-viewer__mask{
    opacity: .8;
  }
  .pavilionImg>>>.el-image-viewer__close{
    color: white;
  }
  .cataloguePavilion>>>.el-image-viewer__canvas{
    padding: 20px;
  }
  .cataContent{
    width: calc(100% - 100px);
  }
  .cataContent >p{
    padding: 0 10px;
    padding-top: 6px;
    font-size: 12px;
    font-weight: 600;
  }
  .pavilionTitle{
    margin-top:22px;
    display: flex;
    justify-content: center;
  }
  .pavilionTitle>div:first-child{
    height: 48px;
    vertical-align: middle;
    font-size: 38px;
    padding-right: 6px;
    border-right: 1px solid #008baf;
    color: #008baf;
  }
  .pavilionTitle>div:last-child{
    padding-left: 12px;
  }
  .pavilionTitle>div>h2{
    color: #333;
    font-size: 19px;
    line-height: 28px;
    font-family: 'FjallaOne-Regular';
  }
  .pavilionTitle>div a{
    font-size: 12px;
    color: #008baf;
    font-weight: 900;
    line-height: 20px;
  }
</style>